module.exports = __webpack_public_path__ + "static/img/logo.f490c1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 2